import { User } from '@practium/shared';

const STORAGE_KEYS = {
	TOKEN: 'practium_token',
	USER: 'practium_user',
	CSRF: 'practium_csrf',
} as const;

const CUSTOM_EVENTS = {
	AUTH_CHANGE: 'practium-auth-change',
} as const;

const dispatchAuthChange = (): void => {
	if (typeof globalThis !== 'undefined') {
		globalThis.dispatchEvent(new Event(CUSTOM_EVENTS.AUTH_CHANGE));
	}
};

const getActiveStorage = (): Storage => {
	return sessionStorage.getItem(STORAGE_KEYS.TOKEN) ? sessionStorage : localStorage;
};

export const authStorage = {
	saveSession: (user: User, token: string, rememberMe?: boolean): void => {
		const storage = rememberMe ? localStorage : sessionStorage;
		const otherStorage = rememberMe ? sessionStorage : localStorage;

		storage.setItem(STORAGE_KEYS.TOKEN, token);
		storage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
		otherStorage.removeItem(STORAGE_KEYS.TOKEN);
		otherStorage.removeItem(STORAGE_KEYS.USER);

		dispatchAuthChange();
	},

	updateToken: (token: string): void => {
		getActiveStorage().setItem(STORAGE_KEYS.TOKEN, token);

		dispatchAuthChange();
	},

	clearSession: (): void => {
		localStorage.removeItem(STORAGE_KEYS.TOKEN);
		localStorage.removeItem(STORAGE_KEYS.USER);
		localStorage.removeItem(STORAGE_KEYS.CSRF);
		sessionStorage.removeItem(STORAGE_KEYS.TOKEN);
		sessionStorage.removeItem(STORAGE_KEYS.USER);
		sessionStorage.removeItem('practium:forBinding');

		dispatchAuthChange();
	},

	getToken: (): string | null => {
		return sessionStorage.getItem(STORAGE_KEYS.TOKEN) || localStorage.getItem(STORAGE_KEYS.TOKEN);
	},

	getUser: (): User | null => {
		const userStr =
			sessionStorage.getItem(STORAGE_KEYS.USER) || localStorage.getItem(STORAGE_KEYS.USER);

		if (!userStr) return null;

		try {
			return JSON.parse(userStr);
		} catch {
			return null;
		}
	},

	hasValidSession: (): boolean => {
		return !!authStorage.getToken();
	},

	isRemembered: (): boolean => {
		return !!localStorage.getItem(STORAGE_KEYS.TOKEN);
	},

	saveCsrf: (csrfToken: string): void => {
		localStorage.setItem(STORAGE_KEYS.CSRF, csrfToken);
	},

	getCsrf: (): string | null => {
		return localStorage.getItem(STORAGE_KEYS.CSRF);
	},
};
